import { render, staticRenderFns } from "./ModeSelection.vue?vue&type=template&id=7038842c&scoped=true&"
import script from "./ModeSelection.vue?vue&type=script&lang=js&"
export * from "./ModeSelection.vue?vue&type=script&lang=js&"
import style0 from "./ModeSelection.vue?vue&type=style&index=0&id=7038842c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7038842c",
  null
  
)

export default component.exports